export class ItemKey {
    supId: String;
    prodCd: String;

    constructor(
        supId: String,
        prodCd: String
    ) {
        this.supId = supId;
        this.prodCd = prodCd;
    }
}
